/**
 * Public website URL of an event, e.g. https://my-trail.startline.be.
 * An optional hash (without the leading "#") deep-links into the page.
 */
export function eventSiteUrl(slug: string, hash?: string): string {
  const base = `https://${slug}.startline.be`
  return hash ? `${base}/#${hash}` : base
}
